import axios from "axios";

export const sapi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/strategy`, withCredentials: true });

export function errText(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (d.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}

export const PARTICIPANT_COLOR = { jon: "#C8F74A", andy: "#6FA8FF", pete: "#F0B35C" };
export const PARTICIPANT_NAME = { jon: "Jon", andy: "Andy", pete: "Pete" };

export const KIND = {
  FACT: { label: "Fact", color: "#C8F74A", bg: "rgba(200,247,74,.14)", hint: "Confirmed commercial fact" },
  ESTIMATE: { label: "Estimate", color: "#6FA8FF", bg: "rgba(111,168,255,.14)", hint: "Leadership estimate" },
  ASSUMPTION: { label: "Assumption", color: "#F0B35C", bg: "rgba(240,181,92,.14)", hint: "System / AI assumption — editable" },
  UNKNOWN: { label: "Unknown", color: "#F07A7A", bg: "rgba(240,122,122,.14)", hint: "Needs validation — excluded from scoring" },
  DEMO: { label: "Demo data", color: "#C99CFF", bg: "rgba(201,156,255,.14)", hint: "Seeded demonstration data" },
};

export const PRIORITY = {
  P0: { label: "P0 · Critical", color: "#F07A7A", bg: "rgba(240,122,122,.14)" },
  P1: { label: "P1 · High", color: "#F0B35C", bg: "rgba(240,181,92,.14)" },
  P2: { label: "P2 · Normal", color: "#6FA8FF", bg: "rgba(111,168,255,.14)" },
};

export const DECISION_STATUS = {
  open: { label: "Open", color: "#F07A7A" },
  in_discussion: { label: "In discussion", color: "#F0B35C" },
  agreed: { label: "Agreed", color: "#C8F74A" },
  deferred: { label: "Deferred", color: "rgba(243,239,230,.5)" },
};

export const ROADMAP_STATUS = {
  proposed: { label: "Proposed", color: "rgba(243,239,230,.55)" },
  approved: { label: "Approved", color: "#C8F74A" },
  in_progress: { label: "In progress", color: "#6FA8FF" },
  done: { label: "Done", color: "#C8F74A" },
  dropped: { label: "Dropped", color: "#F07A7A" },
};

export const QUADRANT = {
  quick_win: { label: "Quick win", color: "#C8F74A" },
  strategic_bet: { label: "Strategic bet", color: "#6FA8FF" },
  longer_term: { label: "Longer-term", color: "#F0B35C" },
  distraction: { label: "Low-priority distraction", color: "#F07A7A" },
  unclassified: { label: "Unclassified", color: "rgba(243,239,230,.5)" },
};

export const gbp = (n, opts = {}) => (n == null ? "—" : `£${Math.round(n).toLocaleString("en-GB", opts)}`);
export const pct = (n) => (n == null ? "—" : `${Math.round(n)}%`);

export function scoreTone(s) {
  if (s == null) return "rgba(243,239,230,.4)";
  if (s >= 70) return "#C8F74A";
  if (s >= 50) return "#F0B35C";
  return "#F07A7A";
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }); } catch { return iso; }
}
